"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveNavigation = exports.saveMajor = exports.removeNavigation = exports.removeMajor = exports.navigationList = exports.majorList = exports.editNavigation = exports.editMajor = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
//专业大类
//分页列表
var majorList = exports.majorList = function majorList(data) {
  return _api.default.request({
    url: '/major/categories/list',
    method: 'post',
    data: data
  });
};
//新增
var saveMajor = exports.saveMajor = function saveMajor(data) {
  return _api.default.request({
    url: '/major/categories/save',
    method: 'post',
    data: data
  });
};
//编辑
var editMajor = exports.editMajor = function editMajor(data) {
  return _api.default.request({
    url: '/major/categories/update',
    method: 'post',
    data: data
  });
};
//删除
var removeMajor = exports.removeMajor = function removeMajor(data) {
  return _api.default.request({
    url: '/major/categories/delete',
    method: 'post',
    data: data
  });
};
//院校版自定义导航
//分页列表
var navigationList = exports.navigationList = function navigationList(data) {
  return _api.default.request({
    url: '/schoolNavigation/navigationList',
    method: 'post',
    data: data
  });
};
//新增
var saveNavigation = exports.saveNavigation = function saveNavigation(data) {
  return _api.default.request({
    url: '/schoolNavigation/saveNavigation',
    method: 'post',
    data: data
  });
};
//编辑
var editNavigation = exports.editNavigation = function editNavigation(data) {
  return _api.default.request({
    url: '/schoolNavigation/editNavigation',
    method: 'post',
    data: data
  });
};
//删除
var removeNavigation = exports.removeNavigation = function removeNavigation(data) {
  return _api.default.request({
    url: '/schoolNavigation/removeNavigation',
    method: 'post',
    data: data
  });
};